<script setup>
import { useSnackBar } from '@/utils/stores/snackbar'

definePage({ meta: { layout: 'blank', unauthenticatedOnly: true } })

const snackbarStore = useSnackBar()
const route = useRoute()
const router = useRouter()
const token = router.currentRoute.value.params.token

const form = ref({
  email: router.currentRoute.value.query?.email ?? "",
  newPassword: '',
  confirmPassword: '',
})

const refForm = ref()
const isPasswordVisible = ref(false)
const isConfirmPasswordVisible = ref(false)

const setupPassword = async () => {
  const res = await $api('/auth/reset-password', {
    method: 'POST',
    body: {
      email: form.value.email,
      password: form.value.newPassword,
      // eslint-disable-next-line camelcase
      password_confirmation: form.value.confirmPassword,
      token,
    },
    onResponseError({ response }) {
      // errors.value = response._data.errors
    },
  })

  snackbarStore.showSnackBar("비밀번호가 변경되었습니다. 변경된 정보로 로그인 하세요.", undefined, undefined,  5000)

  await nextTick(() => {
    router.replace(route.query.to ? String(route.query.to) : '/')
  })
}

const onSubmit = () => {
  refForm.value?.validate().then(({ valid: isValid }) => {
    if (isValid)
      setupPassword()
  })
}
</script>

<template>
  <div class="auth-wrapper d-flex align-center justify-center pa-4">
    <div class="position-relative my-sm-16">
      <!-- 👉 Top shape -->
      <!--
        <VNodeRenderer
        :nodes="h('div', { innerHTML: authV1TopShape })"
        class="text-primary auth-v1-top-shape d-none d-sm-block"
        />
      -->

      <!-- 👉 Bottom shape -->
      <!--
        <VNodeRenderer
        :nodes="h('div', { innerHTML: authV1BottomShape })"
        class="text-primary auth-v1-bottom-shape d-none d-sm-block"
        />
      -->

      <!-- 👉 Auth Card -->
      <VCard
        class="auth-card pa-4"
        max-width="448"
      >
        <VCardText>
          <template #prepend>
            <!--
              <div class="d-flex">
              <VNodeRenderer :nodes="themeConfig.app.logo" />
              </div>
            -->
          </template>

          <!--
            <VCardTitle class="font-weight-bold text-capitalize text-h3 py-1">
            {{ themeConfig.app.title }}
            </VCardTitle>
          -->
          <!--
            <VNodeRenderer
            :nodes="themeConfig.app.logo"
            class="mb-6"
            />
          -->

          <h4
            style="font-size: 1.375rem;"
            class="mb-1"
          >
            임상시험관리시스템(CDMS)
          </h4>
        </VCardText>

        <VCardText class="pt-2">
          <h4 class="text-h4 mb-1">
            비밀번호 설정/재설정 🔒
          </h4>
          <p
            v-if="email"
            class="mb-0"
          >
            for <span class="font-weight-bold">{{ email }}</span>
          </p>
        </VCardText>

        <VCardText>
          <VForm
            ref="refForm"
            @submit.prevent="onSubmit"
          >
            <VRow>
              <!-- email -->
              <VCol
                v-show="!router.currentRoute.value.query.email"
                cols="12"
              >
                <AppTextField
                  v-model="form.email"
                  autofocus
                  label="Email"
                  :rules="[requiredValidator, emailValidator]"
                  type="text"
                />
              </VCol>
              <!-- password -->
              <VCol cols="12">
                <AppTextField
                  v-model="form.newPassword"
                  label="새로운 비밀번호"
                  placeholder="············"
                  :rules="[requiredValidator, passwordValidator]"
                  :type="isPasswordVisible ? 'text' : 'password'"
                  :append-inner-icon="isPasswordVisible ? 'tabler-eye-off' : 'tabler-eye'"
                  @click:append-inner="isPasswordVisible = !isPasswordVisible"
                />
              </VCol>

              <!-- Confirm Password -->
              <VCol cols="12">
                <AppTextField
                  v-model="form.confirmPassword"
                  label="비밀번호 확인"
                  placeholder="············"
                  :rules="[requiredValidator, confirmedValidator(form.confirmPassword, form.newPassword)]"
                  :type="isConfirmPasswordVisible ? 'text' : 'password'"
                  :append-inner-icon="isConfirmPasswordVisible ? 'tabler-eye-off' : 'tabler-eye'"
                  @click:append-inner="isConfirmPasswordVisible = !isConfirmPasswordVisible"
                />
              </VCol>

              <!-- reset password -->
              <VCol cols="12">
                <VBtn
                  block
                  type="submit"
                >
                  비밀번호 설정/재설정
                </VBtn>
              </VCol>

              <!-- back to login -->
              <VCol cols="12">
                <RouterLink
                  class="d-flex align-center justify-center"
                  :to="{ name: 'login' }"
                >
                  <VIcon
                    icon="tabler-chevron-left"
                    class="flip-in-rtl"
                  />
                  <span>로그인 화면으로</span>
                </RouterLink>
              </VCol>
            </VRow>
          </VForm>
        </VCardText>
      </VCard>
    </div>
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth.scss";
</style>
